export default [
    {
        path: '/intellectual',
        name: 'Intellectual',
        component: () => import('../../views/Intellectual.vue')
    }
]
